import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import Skeleton from "./components/Skeleton/Skeleton.component";
import { Provider } from "react-redux";
import { skeletonStore } from "./store";
import { SkeletonActionCreators } from "./actions/actionCreators";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Slide } from "react-toastify";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// import * as serviceWorker from "./serviceWorker";
const subApps = {
    home: {
        title: "Home",
        pathname: "/home",
        listable: true,
        default: true
    },
    halls: {
        permissions: ["list_halls"],
        title: "Halls",
        pathname: "/halls",
        listable: true
    },
    configurations: {
        services: ["configuration"],
        title: "Configurations",
        pathname: "/configurations/",
        listable: false
    },
    auth: {
        services: ["auth"],
        title: "Auth",
        listable: false
    },
    inspect: {
        services: ["inspect"],
        title: "Inspect",
        listable: false
    },
    licenses: {
        services: ["license"],
        title: "Licenses",
        listable: false
    },
    games: {
        //permissions: ["list_games", "list_bundles"],
        permissions: ["list_games"],
        title: "Games",
        pathname: "/games",
        listable: true
    },
    custon_vpp: {
        permissions: ["list_vpp"],
        title: "Custom VPP",
        pathname: "/vpp",
        listable: true
    },
    key: {
        permissions: ["generate_key", "history_key"],
        title: "Configuration Key",
        pathname: "/configuration-key",
        listable: true
    },
    remote_access: {
        title: "Remote Access",
        superuser: true,
        pathname: "/remote-access",
        listable: true
    }
};

skeletonStore.dispatch(SkeletonActionCreators.readSubAppsConfig(subApps));

ReactDOM.render(
    <Provider store={skeletonStore}>
        <ToastContainer transition={Slide} />
        <Skeleton />
    </Provider>,

    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
